module.exports = __webpack_public_path__ + "03_medium_gold.dbb4f327.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/03_medium_gold.png
// module id = 8Hbz
// module chunks = 0